import { useState, useCallback } from 'react';

/**
 * Hook for managing snackbar notifications
 */
export function useNotification() {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success' // 'success' | 'error' | 'warning' | 'info'
  });
  
  // Show notification
  const showNotification = useCallback((message, severity = 'success') => {
    setSnackbar({
      open: true,
      message,
      severity
    });
  }, []);
  
  // Convenience methods for different severities
  const showSuccess = useCallback((message) => {
    showNotification(message, 'success');
  }, [showNotification]);
  
  const showError = useCallback((message) => {
    showNotification(message, 'error');
  }, [showNotification]);
  
  const showWarning = useCallback((message) => {
    showNotification(message, 'warning');
  }, [showNotification]);
  
  const showInfo = useCallback((message) => {
    showNotification(message, 'info');
  }, [showNotification]);
  
  // Close notification
  const closeNotification = useCallback(() => {
    setSnackbar(prev => ({ ...prev, open: false }));
  }, []);
  
  return {
    // State
    snackbar,
    
    // Methods
    showNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    closeNotification
  };
}